import { configureStore } from "@reduxjs/toolkit";
import thunk from "redux-thunk";
import { rootReducer } from "./combineReducers";
import { createTransform, persistReducer, persistStore } from "redux-persist";
import storage from "redux-persist/lib/storage";

/* The job filter tile state is per visit: jobTileFilterRequest is a one shot
   command and activeJobTile only describes the filter the mounted job listing
   is showing. Persisting either one means a reload brings back a selected
   looking tile - or even re-runs the filter - while the listing itself starts
   unfiltered, so both are stripped on the way in and on the way out. */
const stripJobTileState = createTransform(
  (inbound: any) => {
    return { ...inbound, jobTileFilterRequest: null, activeJobTile: null };
  },
  (outbound: any) => {
    return { ...outbound, jobTileFilterRequest: null, activeJobTile: null };
  },
  { whitelist: ["careers"] }
);

const persistConfig = {
  key: "root",
  storage,
  transforms: [stripJobTileState],
};
const persistedReducer = persistReducer(persistConfig, rootReducer);
 const store = configureStore({
  reducer: persistedReducer,
  middleware: [thunk]

});    

const persistor = persistStore(store);
export { store, persistor };
